import React from "react";
import SeoHead from "../components/SeoHead";

export default function PrivacyPage() {
  return (
    <article>
      <SeoHead
        title="Privacy Policy"
        description="How Paysafi collects, uses, and protects your data. Read our full privacy policy."
        path="/privacy"
      />
      <section className="border-b border-gray-100 bg-gray-50 py-16 dark:border-gray-800 dark:bg-gray-900">
        <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
            Privacy Policy
          </h1>
          <p className="mt-3 text-sm text-gray-500">Last updated: April 2026</p>
        </div>
      </section>
      <section className="py-16">
        <div className="mx-auto max-w-3xl space-y-8 px-4 sm:px-6">
          <Block title="1. Introduction">
            Paysafi ("we", "us", "our") is a rent tracking and tenant management platform. This
            Privacy Policy explains how we collect, use, and protect your information when you use
            our website and services.
          </Block>
          <Block title="2. Information we collect">
            <strong>Account information:</strong> name, email address, phone number, and
            authentication credentials when you sign up.
            <br /><br />
            <strong>Property & tenant data:</strong> property names, addresses, tenant details,
            rent amounts, payment records, and communication logs that you enter into the platform.
            <br /><br />
            <strong>Usage data:</strong> browser type, device information, pages visited, and
            interactions with the platform for analytics and improvement purposes.
          </Block>
          <Block title="3. How we use your information">
            We use your information to: provide and maintain the Paysafi service; send rent
            reminders via SMS and AI voice calls on your behalf; generate reports and dashboards;
            improve the platform; and communicate with you about your account and service updates.
          </Block>
          <Block title="4. Data storage & security">
            Your data is stored securely using industry standard encryption on cloud servers. We
            use Firebase Firestore for data persistence and follow industry best practices for
            authentication and access control.
          </Block>
          <Block title="5. Third party services">
            We may use third party services for SMS delivery, AI voice calling, analytics, and
            hosting. These providers are contractually bound to protect your data and use it only
            for the purposes we specify.
          </Block>
          <Block title="6. Your rights">
            You have the right to: access your personal data; correct inaccurate data; delete your
            account and all associated data; export your data; and withdraw consent for
            communications at any time.
          </Block>
          <Block title="7. Data retention">
            We retain your data for as long as your account is active. If you delete your account,
            all personal data, property records, tenant information, and payment history are
            permanently removed within 30 days.
          </Block>
          <Block title="8. Cookies">
            We use essential cookies for authentication and session management. We do not use
            third party tracking cookies. You can manage cookie preferences in your browser
            settings.
          </Block>
          <Block title="9. Changes to this policy">
            We may update this Privacy Policy from time to time. We will notify you of any
            significant changes via email or through the platform.
          </Block>
          <Block title="10. Contact us">
            If you have questions about this Privacy Policy, contact us at{" "}
            <a href="mailto:botibongasolutions@gmail.com" className="font-medium text-indigo-600 hover:text-indigo-700">
              botibongasolutions@gmail.com
            </a>.
          </Block>
        </div>
      </section>
    </article>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
      <p className="mt-2 text-sm leading-relaxed text-gray-600 dark:text-gray-400">{children}</p>
    </div>
  );
}
